<div class="sb-step sb-step-winback">
  <form class="sb-step__form" [formGroup]="formGroup">
    <div class="sb-step__form__content">
      <div class="sb-step__inner-container">
        <div class="sb-form-block" formGroupName="winbackInfo">
          <div class="sb-form-block__title wt-text-align-center">
            {{'ENTITY.WINBACK.TITLE' | translate}}
          </div>
          <div class="sb-form-block__fields">
            <div class="row wt-margin-bottom-4 wt-t">
              <div class="col-tb-offset-4 col-tb-4 col-xs-12">
                <wt-input-text [validateOnBlur]="true" [maxLength]="FormConstants.MAXIMUM_MOBILE_NUMBER_LENGTH" [label]="'ENTITY.CONTACTS.MOBILE' | translate" type="tel" formControlName="mobileNumber"></wt-input-text>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sb-step__form__footer">
      <sb-navigation-buttons [isSticky]="shouldBeSticky" [submitDisabled]="this.formGroup.invalid" (backClick)="goToPreviousStep()" (submitClick)="goToNextStep()"></sb-navigation-buttons>
    </div>
  </form>
</div>

